// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React from 'react';
import { List, ListItem } from '@op/opds.opux';

interface PreviewValue {
    title: string;
    value: string;
}

interface PreviewListProps {
    values: PreviewValue[];
}

const PreviewList: React.FC<PreviewListProps> = ({ values }) => {
    return (
        <List className="previewList" border="none" data-testid="preview-list">
            {values.map(({ title, value }) => (
                <ListItem label={title} key={title} data-testid={`preview-list-item-${title}`}>
                    <div className="preview-value" data-testid={`preview-value-${title}`}>
                        {value}
                    </div>
                </ListItem>
            ))}
        </List>
    );
};

export default PreviewList;
